// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"78e68b03","498":"f93f782b","598":"3882f611"}[chunkId] + ".chunk.js";
};